// extracted by mini-css-extract-plugin
export default {"remoteSearchContainer":"Lko4tr4ATdzjw_lNcFja"};